import axios, { AxiosRequestConfig } from 'axios';
import { Buffer } from 'buffer';
// import { useFileSystem } from '../hooks/useFileSystem';
import { Platform } from 'react-native';
import BackgroundService from 'react-native-background-actions';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import paths, { getStreamURI } from '../api/paths';
// import axios, { AxiosRequestConfig } from 'axios';
import { StreamClient } from '../api/streams/axiosStreamClient';
import { getVideoDetails } from '../api/streams/commonApi';
import { useFileSystem } from '../hooks/useFileSystem';
import {
  FeedUploadStatusEnum,
  ICreateResumableMedia,
  IResumableMedia,
} from '../interface/resumableFeed';
import { IYoutubeImportResponse } from '../interface/videoImportResponse';
import { IRemoteVideoMetadata } from '../interface/videoMetadataResponse';
import { zustandResumableFeedStorage } from '../mmkv/mmkvResumableFeedPeristence';
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';
import { mmkvUserProfilePersistence } from '../mmkv/mmkvUserProfilePersistence';
// import PushNotification from 'react-native-push-notification';
import { LanguageJson } from '../utils/keys';
import { languageMap } from '../utils/languagePreference';
import { displayLocalPush } from '../utils/notifee';
import { useAppPersistenceStore } from './useAppPersistenceStore';
import { useProfileStore } from './useProfileStore';

const peertubeBase = getStreamURI();
const TRANSCODING_INTERVAL = 30000;
let isTransCoding = false;
interface IProgresBarConfig {
  progressPercentage: number;
  isError: boolean;
  isSuccess: boolean;
  inProgress: boolean;
}
interface transCodingQueue {
  [key: string]: IResumableMedia;
}
export interface IResumableFeedStore {
  resumableFeeds: Array<IResumableMedia>;
  addResumableFeed: (feed: IResumableMedia) => void;
  updateResumableFeed: (feed: IResumableMedia) => void;
  removeResumableFeed: (index: number) => void;
  uploadResumableInit: (
    payload: IResumableMedia,
    headers: Record<string, any>
  ) => Promise<string | null | undefined>;
  uploadResumable: (payload: string, data: any, headers: Record<string, any>) => void;
  executeChunkUpload: (payload: IResumableMedia) => Promise<boolean>;
  isAnyTaskRunning: () => boolean;
  publishVideoToPeerTube: (config: {
    videoId: string;
    resumableFeed: IResumableMedia;
    shortUUID: string;
  }) => void;
  // uploadVideoToMastodon: (config: {
  //   payload: {};
  //   header: {};
  //   resumableFeed: IResumableMedia;
  // }) => void;
  progresBarConfig: IProgresBarConfig;
  setProgresBarConfig: (config: IProgresBarConfig) => void;
  isVideoUploding: boolean;
  // setVideoUploding: (flage: boolean) => void;
  transCodingQueue: transCodingQueue;
  setTransCodingQueue: (key: string, value: IResumableMedia) => void;
  removeTransCodingItem: (key: string) => void;
  triggerTransCoding: (videoId: string) => void;
  currentResumableFeed: IResumableMedia;
  setCurrentResumableFeed: (value: IResumableMedia) => void;
  resetResumableFeedStore: () => void;
  onYoutubeImport: (payload: IResumableMedia) => Promise<void>;
  executeYoutubeImportAsService: (payload: IResumableMedia) => Promise<boolean>;
  moderateVideo: (payload: IResumableMedia) => Promise<boolean>;
  extractTags: (desc?: string) => string[] | undefined;
  // removeItem: (item: IResumableFeed) => void;
}

const initialState = {
  resumableFeeds: [],
  currentResumableFeed: {
    feedTitle: '',
    feedDesc: '',
    fileName: '',
    name: '',
    status: FeedUploadStatusEnum.PENDING,
    videoId: '',
    videoPeerTubeUrl: '',
    previewUrl: '',
  },
  progresBarConfig: {
    progressPercentage: 0,
    isError: false,
    isSuccess: false,
    inProgress: false,
  },
  transCodingQueue: {},
};

export const useResumableFeedStore = create<IResumableFeedStore>()(
  devtools(
    persist<IResumableFeedStore>(
      (set, get) => ({
        resumableFeeds: [],
        currentResumableFeed: {
          feedTitle: '',
          feedDesc: '',
          fileName: '',
          name: '',
          status: FeedUploadStatusEnum.PENDING,
          videoId: '',
          videoPeerTubeUrl: '',
          previewUrl: '',
          translation: undefined,
        },
        progresBarConfig: {
          progressPercentage: 0,
          isError: false,
          isSuccess: false,
          inProgress: false,
        },
        transCodingQueue: {},
        setTransCodingQueue: (key: string, value: IResumableMedia) =>
          set((state) => ({
            ...state,
            transCodingQueue: {
              ...state.transCodingQueue,
              [key]: value,
            },
          })),
        removeTransCodingItem: (key: string) => {
          set((state) => {
            const newTransCodingQueue = { ...state.transCodingQueue };
            delete newTransCodingQueue[key];
            return { ...state, transCodingQueue: newTransCodingQueue };
          });
        },
        setProgresBarConfig: (config: IProgresBarConfig) => set({ progresBarConfig: config }),
        addResumableFeed: (feed: IResumableMedia) => {
          feed.feedIndex = get()?.resumableFeeds.length;
          set((state) => ({ resumableFeeds: [...state.resumableFeeds, feed] }));
        },
        setCurrentResumableFeed: (resumableFeed: IResumableMedia) =>
          set({ currentResumableFeed: resumableFeed }),
        removeResumableFeed: (index: number) =>
          set((state) => ({
            resumableFeeds: get()?.resumableFeeds.splice(index, 1),
          })),
        updateResumableFeed: (payload: IResumableMedia) => {
          const feeds = get()?.resumableFeeds;
          feeds[payload.feedIndex!] = payload;
          set(() => ({ resumableFeeds: feeds }));
        },
        uploadResumableInit: async (payload: IResumableMedia, headers) => {
          // useResumableFeedStore.getState().setVideoUploding(false);
          const progresBarConfig = get().progresBarConfig;
          useResumableFeedStore.getState().setProgresBarConfig({
            isError: false,
            isSuccess: false,
            progressPercentage: 0,
            inProgress: true,
          });
          try {
            const createMedia: ICreateResumableMedia = {
              channelId: payload.channelId ?? '1',
              filename: payload.fileName,
              name: payload.name,
            };
            const res = await StreamClient.post(
              `${peertubeBase}/api/v1/videos/upload-resumable`,
              createMedia,
              { headers: headers }
            );

            if (res.status === 201) {
              const remoteLocation = res.headers['location'];
              payload.remoteLocation = remoteLocation;

              return payload.remoteLocation;
            }
          } catch (err) {
            useResumableFeedStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }

          return null;
        },
        uploadResumable: async (remoteLocation: string, data: any, headers) => {
          const progresBarConfig = get().progresBarConfig;
          try {
            const res = await StreamClient.put(`${remoteLocation}`, data, { headers: headers });
          } catch (err) {
            useResumableFeedStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }
        },
        executeChunkUpload: async (resumableFeed: IResumableMedia) => {
          const progresBarConfig = get().progresBarConfig;

          const peerTubeToken = useProfileStore.getState()?.streamConfig?.access_token;
          try {
            if (BackgroundService.isRunning()) {
              console.log('Background task is running. Please wait until it completes...');
              return false;
            }

            const initUpload = get()?.uploadResumableInit;
            const token = `Bearer ${peerTubeToken}`;
            const initHeaders = {
              authorization: token,
              'x-upload-content-length': resumableFeed?.mediaFile?.fileSize,
              'x-upload-content-type': resumableFeed.mediaFile?.mimeType,
            };

            if (initUpload) {
              const remoteLocation = await initUpload(resumableFeed, initHeaders);
              if (remoteLocation) {
                resumableFeed.remoteLocation = remoteLocation;
                resumableFeed.status = FeedUploadStatusEnum.INPROGRESS;
                get()?.updateResumableFeed(resumableFeed);
                const taskDefinition = getBackgroundServiceTaskInfo(resumableFeed);
                await BackgroundService.start(
                  () => uploadFileInChunks(resumableFeed, get()?.updateResumableFeed),
                  taskDefinition
                );
              }
            }
          } catch (err) {
            useResumableFeedStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }

          return true;
        },
        isAnyTaskRunning: () => {
          // BackgroundService.stop();
          return BackgroundService.isRunning();
        },
        triggerTransCoding: async (videoId: string) => {
          if (isTransCoding) {
            return;
          }
          isTransCoding = true;
          const transCodingQueue = useResumableFeedStore.getState()?.transCodingQueue;
          //check if item is alredy present in queue
          if (transCodingQueue[`video_id_${videoId}`]) {
            console.log('Trigger transcoding 2');
            let resumableFeed = transCodingQueue[`video_id_${videoId}`];
            //check if item is alredy isPublished then delete item from queue
            if (transCodingQueue[`video_id_${videoId}`].isPublished) {
              useResumableFeedStore.getState().removeTransCodingItem(`video_id_${videoId}`);
            }

            //check if item is alredy TransCoded then delete item from queue and publish the video
            else if (transCodingQueue[`video_id_${videoId}`].isTransCoded) {
              useResumableFeedStore.getState().publishVideoToPeerTube({
                videoId: videoId,
                resumableFeed: transCodingQueue[`video_id_${videoId}`],
                shortUUID: resumableFeed?.shortUUID,
              });
            } else {
              try {
                const uri = `${getStreamURI()}/api/v1/videos/${videoId}`;
                const getMediaMetadata = await StreamClient.get<IRemoteVideoMetadata>(uri);
                if (getMediaMetadata.status === 200) {
                  if (
                    getMediaMetadata?.data?.files.length > 0 &&
                    getMediaMetadata?.data?.streamingPlaylists?.length === 0
                  ) {
                    console.log('Trigger transcoding 3');
                    await new Promise((resolve) => setTimeout(resolve, TRANSCODING_INTERVAL));
                    isTransCoding = false;
                    useResumableFeedStore?.getState()?.triggerTransCoding(videoId);
                  } else if (getMediaMetadata?.data?.streamingPlaylists?.length > 0) {
                    resumableFeed.duration = getMediaMetadata.data.duration;
                    resumableFeed.previewUrl = `${peertubeBase}${getMediaMetadata.data.thumbnailPath}`;
                    resumableFeed.videoRawUrl =
                      getMediaMetadata.data.duration > 60
                        ? getMediaMetadata?.data?.streamingPlaylists?.[0].playlistUrl
                        : getMediaMetadata?.data?.streamingPlaylists?.[0]?.files?.[0]
                            ?.fileDownloadUrl;
                    resumableFeed.isTransCoded = true;
                    useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
                    useResumableFeedStore
                      .getState()
                      .setTransCodingQueue(`video_id_${videoId}`, resumableFeed);
                    useResumableFeedStore.getState().publishVideoToPeerTube({
                      videoId: videoId,
                      resumableFeed: resumableFeed,
                      shortUUID: resumableFeed.shortUUID,
                    });
                  }
                }
              } catch (error) {
                isTransCoding = false;
                resumableFeed.status = FeedUploadStatusEnum.ERROR;
                useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
                console.error('Error in put video:', error);
                let payload = {
                  title: `${resumableFeed.translation?.('page.error')}`,
                  body: `${resumableFeed.translation?.('page.someThingWentWrong')}`,
                };
                displayLocalPush(payload);
                const progresBarConfig = useResumableFeedStore.getState()?.progresBarConfig;
                useResumableFeedStore
                  .getState()
                  .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
              }
            }
          } else {
            console.log('Trigger transcoding 1');
            const resumableFeed = useResumableFeedStore?.getState().currentResumableFeed;
            useResumableFeedStore
              .getState()
              ?.setTransCodingQueue(`video_id_${videoId}`, resumableFeed);
            isTransCoding = false;
            useResumableFeedStore?.getState()?.triggerTransCoding(videoId);
          }
        },
        publishVideoToPeerTube: async (config) => {
          console.log('Publish peertube video!!!');
          const { videoId, resumableFeed, shortUUID } = config;
          const selectedLanguage = useAppPersistenceStore.getState().appLanguage;
          try {
            const tags = get()?.extractTags(resumableFeed.feedDesc);
            const extraTags = isShortOrLongVideo(resumableFeed?.duration);
            if (extraTags) tags?.push(extraTags);

            const publishRes = await StreamClient.put(
              `${getStreamURI()}/api/v1/videos/${videoId}`,
              {
                name: resumableFeed.fileName,
                category: null,
                licence: null,
                language: selectedLanguage ? LanguageJson[selectedLanguage] : 'en',
                support: null,
                description: resumableFeed.feedDesc,
                channelId: resumableFeed.channelId,
                privacy: 2,
                tags: tags,
                nsfw: false,
                waitTranscoding: true,
                commentsEnabled: true,
                downloadEnabled: true,
                scheduleUpdate: null,
                originallyPublishedAt: null,
              }
            );
            if (publishRes.status === 204) {
              // resumableFeed.videoId = videoId;
              // resumableFeed.videoPeerTubeUrl = `${peertubeBase}/w/${shortUUID}`;
              // useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
              // const config = {
              //   payload: {
              //     status:
              //       resumableFeed?.duration! > 60
              //         ? `${resumableFeed.feedDesc}\n ${resumableFeed.videoPeerTubeUrl}\n #system_longvideo #system_${selectedLanguage} #${toolId()}`
              //         : `${resumableFeed.feedDesc}\n ${resumableFeed.videoPeerTubeUrl}\n #system_shortvideo #system_${selectedLanguage} #${toolId()}`,
              //     in_reply_to_id: null,
              //     media_ids: [],
              //     sensitive: false,
              //     spoiler_text: '',
              //     visibility: 'public',
              //     poll: null,
              //     language: 'en',
              //   },
              //   header: { authorization: `Bearer ${feedConfig}` },
              //   resumableFeed: resumableFeed,
              // };
              // const feedConfig = useProfileStore.getState().feedConfig;
              // const CreateModerationbody = {
              //   input: {
              //     systemType: 'post',
              //     status:
              //       resumableFeed?.duration! > 60
              //         ? `${resumableFeed.feedDesc}\n ${resumableFeed.videoPeerTubeUrl}\n #system_longvideo #system_${selectedLanguage} #${toolId()}`
              //         : `${resumableFeed.feedDesc}\n ${resumableFeed.videoPeerTubeUrl}\n #system_shortvideo #system_${selectedLanguage} #${toolId()}`,
              //     in_reply_to_id: null,
              //     media_ids: [],
              //     sensitive: false,
              //     spoiler_text: '',
              //     visibility: 'public',
              //     poll: null,
              //     language: 'en',
              //     Authorization: `Bearer ${feedConfig}`,
              //   },
              // };
              // let payload = {
              //   userId: useProfileStore.getState()?.userProfile?.user.id || '',
              //   realmId: useProfileStore.getState()?.userProfile?.realm?.id || '',
              // };
              // useResumableFeedStore.getState().uploadVideoToMastodon(config);
              await get()?.moderateVideo(resumableFeed);
              isTransCoding = false;
              const progresBarConfig = useResumableFeedStore.getState().progresBarConfig;
              // useResumableFeedStore.getState().setVideoUploding(true);
              config.resumableFeed.status = FeedUploadStatusEnum.COMPLETE;
              config.resumableFeed.isPublished = true;
              useResumableFeedStore.getState().updateResumableFeed(config.resumableFeed);

              useResumableFeedStore
                .getState()
                .setProgresBarConfig({ ...progresBarConfig, isSuccess: true, inProgress: false });
              useResumableFeedStore
                .getState()
                .removeTransCodingItem(`video_id_${config.resumableFeed.videoId}`);
              const bg_payload = {
                title: `${config.resumableFeed.translation?.('page.success')}`,
                body: `${config.resumableFeed.translation?.('page.videoUploadSuccessfully')}`,
              };
              displayLocalPush(bg_payload);

              // const { post } = await moderationPostQuestionAndFeedAsync(
              //   payload,
              //   CreateModerationbody
              // );
            }
          } catch (error) {
            isTransCoding = false;
            resumableFeed.status = FeedUploadStatusEnum.ERROR;
            useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
            console.error('Error in put video:', error);
            let payload = {
              title: `${resumableFeed.translation?.('page.error')}`,
              body: `${resumableFeed.translation?.('page.someThingWentWrong')}`,
            };
            displayLocalPush(payload);
            const progresBarConfig = useResumableFeedStore.getState()?.progresBarConfig;
            useResumableFeedStore
              .getState()
              .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
          } finally {
            BackgroundService.stop();
          }
        },
        // uploadVideoToMastodon: async (config: {
        //   payload: {};
        //   header: {};
        //   resumableFeed: IResumableMedia;
        // }) => {
        //   try {
        //     const res = await NetworkApi.post(
        //       paths.postContentInMastodon(),
        //       config.payload,
        //       config.header
        //     );
        //     if (res) {
        //       let progresBarConfig = useResumableFeedStore.getState().progresBarConfig;
        //       const videoList = useFeedStore.getState().longVideos;
        //       const shortVideo = useFeedStore.getState().shortVideos;
        //       res['card'] = {
        //         image: config?.resumableFeed?.previewUrl,
        //         url: config?.resumableFeed?.previewUrl,
        //         videoId: config?.resumableFeed?.videoId,
        //       };
        //       if (config.resumableFeed?.duration && config.resumableFeed?.duration > 60) {
        //         const postContent: any = transFormStreamRes([res]);
        //         videoList.unshift(...postContent);
        //         useFeedStore.getState().setLongVideos(videoList);
        //       } else {
        //         res['videoUri'] = res['videoUri'] ?? config?.resumableFeed?.videoRawUrl;
        //         shortVideo.unshift(res as IshortVideo);
        //         useFeedStore.getState().setShortVideos(shortVideo);
        //       }
        //       // useResumableFeedStore.getState().setVideoUploding(true);
        //       config.resumableFeed.status = FeedUploadStatusEnum.COMPLETE;
        //       config.resumableFeed.isPublished = true;
        //       isTransCoding = false;
        //       useResumableFeedStore.getState().updateResumableFeed(config.resumableFeed);
        //       BackgroundService.stop();
        //       useResumableFeedStore
        //         .getState()
        //         .setProgresBarConfig({ ...progresBarConfig, isSuccess: true, inProgress: false });
        //       useResumableFeedStore
        //         .getState()
        //         .removeTransCodingItem(`video_id_${config.resumableFeed.videoId}`);
        //       let payload = {
        //         title: `${config.resumableFeed.translation?.('page.success')}`,
        //         body: `${config.resumableFeed.translation?.('page.videoUploadSuccessfully')}`,
        //       };
        //       displayLocalPush(payload);
        //     }
        //   } catch (error) {
        //     isTransCoding = false;
        //     config.resumableFeed.status = FeedUploadStatusEnum.ERROR;
        //     useResumableFeedStore.getState().updateResumableFeed(config.resumableFeed);
        //     console.error('Error in put video:', error);
        //     let payload = {
        //       title: `${config.resumableFeed.translation?.('page.error')}`,
        //       body: `${config.resumableFeed.translation?.('page.someThingWentWrong')}`,
        //     };
        //     displayLocalPush(payload);
        //     const progresBarConfig = useResumableFeedStore.getState()?.progresBarConfig;
        //     useResumableFeedStore
        //       .getState()
        //       .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
        //   }
        // },
        isVideoUploding: false,
        // setVideoUploding: (flage: boolean) => set({ isVideoUploding: flage }),
        resetResumableFeedStore: () => {
          mmkvUserProfilePersistence.delete(MMKVStoreKeyMap.resumableFeedStore);
          set(initialState);
        },
        executeYoutubeImportAsService: async (resumableFeed: IResumableMedia) => {
          if (BackgroundService.isRunning()) {
            console.log('Background task is running. Please wait until it completes...');
            return false;
          }

          const taskDefinition = getBackgroundServiceTaskInfo(resumableFeed);
          resumableFeed.status = FeedUploadStatusEnum.INPROGRESS;
          get()?.updateResumableFeed(resumableFeed);
          await BackgroundService.start(
            () => get()?.onYoutubeImport(resumableFeed),
            taskDefinition
          );

          return true;
        },
        onYoutubeImport: async (resumableFeed: IResumableMedia) => {
          try {
            if (!resumableFeed?.importStatus) {
              BackgroundService.updateNotification({
                progressBar: { value: 25, max: 100, indeterminate: false },
              });

              const videoImportUri = paths.importYoutubeVideo();
              const importPayload = {
                language: null,
                description: resumableFeed?.feedDesc,
                channelId: resumableFeed.channelId,
                privacy: 1,
                waitTranscoding: false,
                targetUrl: resumableFeed.remoteLocation,
              };

              const importYoutubeVideo = await StreamClient.post<IYoutubeImportResponse>(
                videoImportUri,
                importPayload,
                {
                  timeout: 180000,
                }
              );

              if (importYoutubeVideo?.data?.state?.id) {
                BackgroundService.updateNotification({
                  progressBar: { value: 50, max: 100, indeterminate: false },
                });
                const videoDetails = importYoutubeVideo?.data?.video;
                if (videoDetails?.id) {
                  resumableFeed.remoteLocation = videoDetails?.url;
                  resumableFeed.videoPeerTubeUrl = videoDetails?.url;
                  resumableFeed.importStatus = true;
                  resumableFeed.videoId = videoDetails?.id ?? null;
                  get()?.updateResumableFeed(resumableFeed);
                }
              }
            }

            if (resumableFeed.videoId) {
              const checkVideoStatus = await getVideoDetails(resumableFeed.videoId);
              if ([1, 2].includes(checkVideoStatus?.data?.state?.id ?? 0)) {
                BackgroundService.updateNotification({
                  progressBar: { value: 100, max: 100, indeterminate: false },
                });
                const bg_payload = {
                  title: `${resumableFeed.translation?.('page.success')}`,
                  body: `${resumableFeed.translation?.('page.videoUploadSuccessfully')}`,
                };

                const createTicketPayload = {
                  input: {
                    processId: 176,
                    videoId: resumableFeed?.videoId,
                  },
                };

                const createTicketPost = paths.createVideoTicket(
                  useProfileStore?.getState()?.userProfile?.realm?.id,
                  useProfileStore.getState().userProfile?.user?.id
                );

                const headers = {
                  Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
                  'x-nc-system-user-id': useProfileStore?.getState()?.userProfile?.user?.id ?? 1,
                };

                const createVideoTicket = await axios.post(createTicketPost, createTicketPayload, {
                  headers,
                  timeout: 60000,
                });

                displayLocalPush(bg_payload);
                BackgroundService.stop();
                return;
              }

              await delay(60000);
              return get()?.onYoutubeImport(resumableFeed);
            }
          } catch (error) {
            console.error('Error while youtube import => ', error);
            if (BackgroundService.isRunning()) BackgroundService.stop();
          }
        },
        moderateVideo: async (resumableFeed: IResumableMedia) => {
          if (resumableFeed.videoId) {
            const checkVideoStatus = await getVideoDetails(resumableFeed.videoId);
            if ([1, 2].includes(checkVideoStatus?.data?.state?.id ?? 0)) {
              BackgroundService.updateNotification({
                progressBar: { value: 100, max: 100, indeterminate: false },
              });
              const bg_payload = {
                title: `${resumableFeed.translation?.('page.success')}`,
                body: `${resumableFeed.translation?.('page.videoUploadSuccessfully')}`,
              };

              const selectedLanguage = useAppPersistenceStore.getState().appLanguage ?? 'hi';
              const createTicketPayload = {
                input: {
                  processId: 176,
                  videoId: resumableFeed?.videoId?.toString(),
                  languagePreference: languageMap[selectedLanguage] ?? 1,
                  systemType: 'post',
                },
              };

              const createTicketPost = paths.createVideoTicket(
                useProfileStore?.getState()?.userProfile?.realm?.id,
                useProfileStore.getState().userProfile?.user?.id
              );

              const headers = {
                Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
                'x-nc-system-user-id': useProfileStore?.getState()?.userProfile?.user?.id ?? 1,
              };

              const createVideoTicket = await axios.post(createTicketPost, createTicketPayload, {
                headers,
                timeout: 60000,
              });

              displayLocalPush(bg_payload);
              // BackgroundService.stop();
              return true;
            }
          }
          return true;
        },
        extractTags: (desc: string) => {
          if (!desc) {
            return [];
          }

          const hashtagRegex = /#(\w+)/g;
          const matches: string[] = [];
          let match: RegExpExecArray | null;

          while ((match = hashtagRegex.exec(desc)) !== null) {
            matches.push(match[1]);
          }

          return matches ?? [];
        },
      }),
      {
        name: MMKVStoreKeyMap.resumableFeedStore,
        storage: createJSONStorage(() => zustandResumableFeedStorage),
      }
    ),
    { enabled: false }
  )
);

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const getBackgroundServiceTaskInfo = (resumableFeed: IResumableMedia) => {
  const options = {
    taskName: 'NinjaKisaanFileUpload',
    taskTitle: `Uploading ${trimFileName(resumableFeed.fileName)}`,
    taskDesc: 'Progress',
    taskIcon: {
      name: 'ic_launcher',
      type: 'mipmap',
    },
    color: '#ff00ff',
    progressBar: {
      max: 100,
      value: 0,
      indeterminate: false,
    },
    //change this for opening the app from notification
    //linkingURI: 'uploadFile',
  };

  return options;
};

const trimFileName = (filename: string) => {
  if (filename) {
    const split = filename.split('.');
    let filenameRaw = split[0];
    const extension = split[1];

    if (filenameRaw.length > 10) {
      filename = filename.substring(0, 10);
      let result = filename + '.' + extension;
      return result;
    }

    return filename;
  }
};

const uploadFileInChunks = async (resumableFeed: IResumableMedia, statusUpdate) => {
  const { remoteLocation } = resumableFeed;
  let progresBarConfig = useResumableFeedStore.getState().progresBarConfig;

  try {
    const requestConfig: AxiosRequestConfig = getAxiosRequestConfig();
    const axiosHeaders = requestConfig.headers;
    let fileBuffer: any;
    if (Platform.OS === 'web') {
      const arrayBuffer = await resumableFeed.mediaFile?.file?.arrayBuffer()!;
      fileBuffer = Buffer.from(arrayBuffer);
    }
    const fileSize =
      Platform.OS !== 'web' ? resumableFeed?.mediaFile?.fileSize! : fileBuffer!.length!;
    const { readFile } = useFileSystem();

    let offset = 0;
    const chunkSize = 3 * 1024 * 1024;

    while (offset < fileSize) {
      // const chunk = await RNFS.read(resumableFeed?.mediaFile?.uri!, chunkSize, offset, 'base64');
      let buffer: any;
      if (Platform.OS !== 'web') {
        buffer = await readFile(resumableFeed?.mediaFile?.uri!, chunkSize, offset, 'base64');
      } else {
        buffer = await readFile(fileBuffer!, chunkSize, offset, 'base64');
      }
      const readFrom = offset;
      const readTil = Math.min(offset + chunkSize, fileSize);
      axiosHeaders!['content-range'] = `bytes ${readFrom}-${readTil}/${fileSize}`;

      // const buffer = Buffer.from(chunk, 'base64');
      axiosHeaders!['Content-Length'] = buffer.length;

      BackgroundService.updateNotification({
        progressBar: { value: (offset / fileSize) * 100, max: 100, indeterminate: false },
      });
      useResumableFeedStore.getState().setProgresBarConfig({
        ...progresBarConfig,
        progressPercentage: (offset / fileSize) * 100,
        inProgress: true,
      });
      const res = await StreamClient.put(`${remoteLocation}`, buffer, requestConfig);
      if (res.status === 308) {
        offset += chunkSize;
        resumableFeed.offsetFrom = offset;
        useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
        BackgroundService.updateNotification({
          progressBar: { value: (offset / fileSize) * 100, max: 100, indeterminate: false },
        });
        useResumableFeedStore.getState().setProgresBarConfig({
          ...progresBarConfig,
          progressPercentage: (offset / fileSize) * 100,
          inProgress: true,
        });
        continue;
      }

      if (res.status === 200) {
        useResumableFeedStore.getState().setProgresBarConfig({
          isError: false,
          isSuccess: false,
          progressPercentage: 100,
          inProgress: true,
        });
        const { id, shortUUID } = res?.data?.video;
        if (id && shortUUID) {
          resumableFeed.videoId = id;
          resumableFeed.shortUUID = shortUUID;
          useResumableFeedStore.getState().updateResumableFeed(resumableFeed);
          useResumableFeedStore?.getState().setCurrentResumableFeed(resumableFeed);
          isTransCoding = false;
          useResumableFeedStore.getState().triggerTransCoding(id);
        }
        break;
      }
    }
  } catch (err) {
    resumableFeed.status = FeedUploadStatusEnum.ERROR;
    statusUpdate(resumableFeed);
    console.error('Error in put video:', err);
    let payload = {
      title: `${resumableFeed.translation?.('page.error')}`,
      body: `${resumableFeed.translation?.('page.someThingWentWrong')}`,
    };
    displayLocalPush(payload);
    useResumableFeedStore
      .getState()
      .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
  } finally {
  }
};

const getAxiosRequestConfig = () => {
  const peerTubeToken = useProfileStore.getState()?.streamConfig?.access_token;
  const requestConfig: AxiosRequestConfig = {
    onUploadProgress: function (progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
    },
  };

  requestConfig.validateStatus = (status: number) => {
    return status >= 200 && status < 309;
  };

  const videoSegmentedHeader = {
    'content-type': 'application/octet-stream',
    authorization: `Bearer ${peerTubeToken}`,
  };

  requestConfig.headers = videoSegmentedHeader;
  return requestConfig;
};

const isShortOrLongVideo = (duration?: number) => {
  if (!duration) {
    return undefined;
  }

  if (duration > 60) {
    return 'system_longVideo';
  }

  if (duration < 60) {
    return 'system_shortVideo';
  }

  return undefined;
};
